<script>
  import USHouseLegend from './USHouseLegend.svelte';
  import UncalledLegend from './UncalledLegend.svelte';
  import ElectionTrends from './ElectionTrends.svelte';
  import HouseSeats from './HouseSeats.svelte';

  export let feed;

  /** @type {number | undefined} */
  let width;
  $: compact = width !== undefined && width <= 680;
</script>

<div class="us-house-trends" bind:clientWidth={width}>
  <ElectionTrends
    {feed}
    level="house"
    let:fillClass
    let:borderClass
    let:holdoversClass
    let:netChanges
    let:uncalled
  >
    <div class="us-house-chart">
      <div class="us-house-seats">
        <HouseSeats
          {fillClass}
          {borderClass}
          {holdoversClass}
          {netChanges}
        />

        <div class="us-house-legend-placement">
          <UncalledLegend {uncalled} {compact} />
          <USHouseLegend {compact} />
        </div>
      </div>
    </div>
  </ElectionTrends>
</div>